import { render, staticRenderFns } from "./CommercialClaimDetails.vue?vue&type=template&id=397c3a34&scoped=true&"
import script from "./CommercialClaimDetails.vue?vue&type=script&lang=js&"
export * from "./CommercialClaimDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "397c3a34",
  null
  
)

export default component.exports